import React from 'react'

const NotationsSCT = () => {
  return (
    <div className='my-6'>
        {/* 特定商取引法に基づく表示 */}
        <h2 className='text-2xl text-center mb-6'>特定商取引法に基づく表示</h2>

        <table className='mx-auto max-w-2xl px-2'>
            <tbody className='[&_th]:p-2 [&_th]:bg-gray-100 [&_th]:border [&_th]:border-purple-300 [&_td]:p-2 [&_td]:border [&_td]:border-purple-300 bg-purple-50'>
                <tr>
                    <th className='min-w-36'>販売業者</th>
                    <td>合同会社FunAMP 大規模鬼ごっこ事務局</td>
                </tr>
                <tr>
                    <th>運営統括責任者名</th>
                    <td>松浦竜征</td>
                </tr>
                <tr>
                    <th>住所</th>
                    <td>東京都新宿区西新宿三丁目3番13号 西新宿水間ビル2階</td>
                </tr>
                <tr>
                    <th>メールアドレス</th>
                    <td>
                        <a className='underline' href='mailto:metrotagcomittee@gmail.com'>metrotagcomittee@gmail.com</a>
                        <p className='text-sm text-gray-700'>電話番号はメールアドレスにてご請求をいただければ、遅滞なく開示いたします。</p>
                    </td>
                </tr>
                <tr>
                    <th>URL</th>
                    <td>
                        <a className='underline' href='https://funamp.jp/'>https://funamp.jp/</a>
                    </td>
                </tr>
                <tr>
                    <th>料金</th>
                    <td>ゲーム運営者によるゲーム実行の際、「アクティベートコイン」を所定の料金で購入し、それを消費します。金額は購入画面に記載。<br/>その他の料金（送料など）については請求しません。</td>
                </tr>
                <tr>
                    <th>返品と払い戻し</th>
                    <td>購入した「アクティベートコイン」は即座に提供され、返品・払い戻しは受け付けておりません。<br/>ただし、支払いから2週間以内に「アクティベートコイン」を付与されない場合や、支払いから2週間以上システム不具合などによってゲームの実行が不可能な場合、購入者の要望を受けてアクティベートコインの付与取消しを行い、料金の払い戻しを行います。</td>
                </tr>
                <tr>
                    <th>支払い方法</th>
                    <td>クレジットカード決済（Square社の決済システムを利用）</td>
                </tr>
                <tr>
                    <th>販売および支払い時期</th>
                    <td>基本的には購入者の任意の時期に商品を購入・料金を支払いすることができます。ただし、当事務局の都合により、予告なく販売を中止することがあります。</td>
                </tr>
                <tr>
                    <th>ソフトウェア使用環境</th>
                    <td>本Webアプリは、最新版のGoogle Chrome, Safari, Microsoft Edgeでの動作に対応します。</td>
                </tr>
                <tr>
                    <th>販売数量</th>
                    <td>特に制限なし</td>
                </tr>
            </tbody>
        </table>
    </div>
  )
}

export default NotationsSCT